<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.849 12H11.5823" stroke="#015D52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M17.7422 17.1332L22.5333 11.9999L17.7422 6.86658"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3201 5.125V1H2V23H14.3201V18.875"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
